// import 'mewe/templates/application';
import { getOwner } from '@ember/application';
import Route from 'mewe/routes/route';
import Session from 'mewe/shared/session';
import browserClasses from 'mewe/utils/browser-classes';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import PS from 'mewe/utils/pubsub';
import { getConfigCatFlagPromise } from 'mewe/shared/config-cat';
import Verbose from 'mewe/utils/verbose';
const verbose = Verbose({ prefix: '[Application Route]' }).log;

export default class ApplicationRoute extends Route {
  @service router;
  @service account;
  @service analytics;
  @service features;

  constructor() {
    super(...arguments);

    // Mixpanel initialisation
    this.analytics.initialise();

    this.router.on('routeDidChange', () => {
      // when some link is clicked in SS we want to always close SS
      PS.Pub('close.smart.search');
    });

    this.loadFeatureFlags();
  }

  loadFeatureFlags() {
    // keep in mind that we have some flags hardcoded in mewe/config/environment.js
    // more info about embers addon for feature flags: https://github.com/kategengler/ember-feature-flags

    const flagsForApplication = [
      'web_are_ai_stickers_enabled',
      'web__are_trending_hashtags_enabled',
      'web_is_gamification_enabled',
      'web__is_apple_auth_enabled',
      'web__is_google_auth_enabled',
      'web__are_profile_recommendations_enabled',
      'web__are_group_recommendations_enabled',
      'web__is_one_feed_enabled',
      'web__is_following_feed_disabled',
      'web__is_wallet_enabled',
    ];

    flagsForApplication.forEach((flag) => {
      getConfigCatFlagPromise(flag).then((value) => {
        Verbose({ prefix: '[ConfigCat]' }).log(`ConfigCat flag ${flag}: ${value}`);

        if (value) {
          this.features.enable(flag);
        }
      });
    });
  }

  beforeModel(transition) {
    if (transition.to.name.match(/^join-page-front/)) {
      let params = this.paramsFor('join-page-front');

      return Session.isAuthenticated().then(({ isAuthenticated }) => {
        if (isAuthenticated) {
          this.router.replaceWith(window.location.pathname.replace('p-front', 'p'));
        } else {
          if (params && params.page_public_id) {
            this.router.transitionTo('join-page', params.page_public_id);
          }
        }
      });
    }
  }

  activate() {
    const { body } = getOwner(this).lookup('service:-document');

    body.classList.add(...browserClasses());
  }

  @action
  error(error) {
    if (error && error.status === 401) {
      this.get('session').invalidate();
    }

    //Global 404 handler, this will catch 404 if not handle 404 somewhere else
    if (error && error.status === 404) {
      location.href = '/404';
    }

    return true;
  }
}
